import cx from 'classnames';
import {filter, map} from 'lodash';
import {useMemo} from 'react';

type SubtitleMessage = {
    id: string;
    participantName: string;
    text: string;
}

const DEFAULT_CONTAINER_CLASSNAME = 'tw-w-full tw-flex-center tw-flex-col tw-bottom-10 tw-z-5';

const DEFAULT_ITEM_CLASSNAME = `
    tw-bg-default tw-text-lg tw-px-2 tw-py-1 tw-my-0.5 tw-bg-opacity-70 
    tw-rounded-lg tw-border tw-border-default-dimmed`;

type Props = {
    messages: SubtitleMessage[];
    containerClassName?: string;
    itemClassName?: string;
}

export const SubtitlesMessages: React.FC<Props> = ({
    messages,
    containerClassName = DEFAULT_CONTAINER_CLASSNAME,
    itemClassName = DEFAULT_ITEM_CLASSNAME
}) => {
    const visibleMessages = useMemo(() => filter(messages, (m) => !!m.text), [messages]);

    return (
        <div className={cx('subtitles tw-absolute', containerClassName)}>
            {map(visibleMessages, (m: SubtitleMessage) => (
                <div
                    key={m.id}
                    className={cx('tw-flex', itemClassName)}
                >
                    <div className='tw-font-bold tw-mr-2'>{`${m.participantName}:`}</div>
                    <div>{m.text}</div>
                </div>
            ))}
        </div>
    );
};